export default __webpack_public_path__ + "static/media/tab_lecturer1_large.4cbf6a12.png";